import { Bell, HelpCircle } from 'lucide-react';
import { Crest } from '@/components/shared/Crest';

export type ShellTab = 'home' | 'board' | 'events' | 'food' | 'profile';

const TITLES: Record<ShellTab, string> = {
  home: 'Bag Tag',
  board: 'Leaderboard',
  events: 'Tournaments',
  food: 'Clubhouse',
  profile: 'Profile',
};

interface Props {
  tab: ShellTab;
  unread: number;
  onOpenActivity: () => void;
  onOpenFAQ: () => void;
}

export function Header({ tab, unread, onOpenActivity, onOpenFAQ }: Props) {
  return (
    <header
      className="ui-chrome sticky top-0 z-30 border-b border-line bg-[rgba(250,250,246,0.85)] backdrop-blur-[20px] backdrop-saturate-[180]"
      style={{
        padding: '12px 20px',
        WebkitBackdropFilter: 'saturate(180%) blur(20px)',
      }}
    >
      <div className="flex items-center gap-[10px]">
        <Crest size={40} variant="gold" />
        <div className="min-w-0 flex-1">
          <div className="font-serif text-[22px] font-bold leading-[1.05] tracking-[-0.02em] text-ink">
            {TITLES[tab]}
          </div>
          <div className="mt-px text-[10px] font-semibold tracking-[0.06em] text-mute">
            INDEPENDENT MEMBERS&apos; APP
          </div>
        </div>
        <button
          type="button"
          onClick={onOpenActivity}
          className="relative flex h-9 w-9 items-center justify-center rounded-[10px] border border-gold-deep bg-gold text-navy shadow-bt"
          title="Activity"
        >
          <Bell size={17} strokeWidth={2.3} />
          {unread > 0 && (
            <span className="absolute -right-1 -top-1 min-w-[17px] rounded-full border-2 border-cream bg-red-600 px-1 text-center text-[10px] font-bold text-white">
              {unread > 99 ? '99+' : unread}
            </span>
          )}
        </button>
        <button
          type="button"
          onClick={onOpenFAQ}
          className="flex h-9 w-9 items-center justify-center rounded-[10px] border border-gold-deep bg-gold text-navy shadow-bt"
          title="FAQ & Help"
        >
          <HelpCircle size={17} strokeWidth={2.3} />
        </button>
      </div>
    </header>
  );
}
